<template>
  <div class="map-filters">
    <h2>{{this.$root.contentText.selection}}</h2>

    <div class="cat-filters">
      <input @change="onChangeCat" id="commerce" type="checkbox" v-model="checkedCats" value="commerce">
      <label for="commerce">{{this.$root.contentText.commerce}}</label>
      <input @change="onChangeCat" id="mixity" type="checkbox" v-model="checkedCats" value="mixity">
      <label for="mixity">{{this.$root.contentText.mixite}}</label>
    </div>

    <div class="type-filters">
      <input @change="onChangeType" id="patrimony" type="checkbox" v-model="checkedTypes" value="patrimony">
      <label for="patrimony">{{this.$root.contentText.actif}}</label>
      <input @change="onChangeType" id="projects" type="checkbox" v-model="checkedTypes" value="project">
      <label for="projects">{{this.$root.contentText.projet}}</label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mapFilters',
    data() {
      return {
        checkedCats: ['commerce', 'mixity'],
        checkedTypes: ['project', 'patrimony'],
      }
    },
    methods: {
      onChangeCat: function () {
        this.$root.setFilter('acf.place_cat', this.checkedCats)
      },
      onChangeType: function () {
        this.$root.setFilter('acf.place_type', this.checkedTypes)
      }
    },
    created() {
      this.$root.setFilter('acf.place_cat', this.checkedCats)
      this.$root.setFilter('acf.place_type', this.checkedTypes)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  h2 {
    text-align: center;
  }

  .cat-filters {
    input {
      display: none;
    }

    input:not(:checked) + label {
      color: #bfc5ca;

      &::before {
        background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FscXVlXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMjYgMzMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2IDMzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojQkZDNUNBO30NCjwvc3R5bGU+DQo8dGl0bGU+VUkvSWNvbi9QaW5QbGFpbiBDb3B5IDY8L3RpdGxlPg0KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQo8ZyBpZD0iTWFxdWV0dGUtLS1BbGwtIj4NCgk8ZyBpZD0iX3gzMF80LS0tTGVzLWxpZXV4LS0tMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNzYuMDAwMDAwLCAtMTk3OS4wMDAwMDApIj4NCgkJPGcgaWQ9IlVJX3gyRl9JY29uX3gyRl9QaW5QbGFpbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3MS4wMDAwMDAsIDE5NzguMDAwMDAwKSI+DQoJCQk8cGF0aCBpZD0icGxhY2Vob2xkZXIiIGNsYXNzPSJzdDAiIGQ9Ik0xOCw4Yy0zLjYsMC02LjYsMy02LjYsNi42czMsNi42LDYuNiw2LjZzNi42LTMsNi42LTYuNlMyMS42LDgsMTgsOHogTTE4LDEuNw0KCQkJCWM3LDAsMTIuNyw1LjcsMTIuNywxMi43YzAsMC44LTAuMSwxLjYtMC4yLDIuNGMwLDAuMSwwLDAuMy0wLjEsMC40Yy0wLjIsMC45LTAuNSwxLjctMC45LDIuNWMtMS4zLDMuMS00LjIsNy44LTEwLjQsMTMNCgkJCQljLTAuMywwLjMtMC43LDAuNC0xLjIsMC40cy0wLjgtMC4xLTEuMi0wLjRjLTYuMi01LjItOS4xLTkuOS0xMC40LTEzQzYsMTksNS44LDE4LjEsNS42LDE3LjNjLTAuMS0wLjMtMC4xLTAuNC0wLjEtMC40DQoJCQkJYy0wLjItMS4yLTAuMy0yLjQtMC4yLTMuNkM1LjksNi45LDExLjIsMiwxNy41LDEuOEMxNy43LDEuNywxNy44LDEuNywxOCwxLjd6IE0xOCwxOS42YzIuOCwwLDUtMi4yLDUtNXMtMi4yLTUtNS01cy01LDIuMi01LDUNCgkJCQlTMTUuMiwxOS42LDE4LDE5LjZ6Ii8+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==");
      }
    }

    label {
      display: flex;
      align-items: center;
      margin: 3px 0;
      padding: 8px 0;
      border-radius: 25px;
      font-size: 17px;
      color: #CB6140;

      &:before {
        content: '';
        display: inline-block;
        width: 26px;
        height: 32px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAiCAYAAABMfblJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAIgAAAAB6rPJFAAAFCUlEQVRIDa1Wb2wUVRCfebtX22oxYg2CUksMjVWbQu/OGk0srS2iRNRgqyb+odcW5QtGY/ggBg4TIMQ/X6zGSO8KIooWtNYoFLm2YIwB7q4JtR8MJKXUQBRRENDSu91x3jZ72dvbvasN78ubN/9+8+bNzC5CjkVEGG9rqCZdfxxAv4cAShHgVt7HAfAMEp0GxB8EqD0LQ/tjiMgi98W2zouCQREbG3iOCNYDwTxnrXQuIpwgEut84cguN2BHwFhrfTlpyc851Ip0l1M8IQzmAT5TGe7/xW4h7Ix4oHY56ckj0waTDgkWJgAOH22tfcTuP+2GDLZMI/iSLRS74nTOnFYdEJb5Qv3fmvYpwHigwadR4hALCkzhVdkRLqKq3u/76MCQ9GeklAtE1SkR5nNWMBkxRziEgL1M/8hF8lfOoAiKKJn8lL5oNLKmSoPYqYGXs70ZO/+HU/P2NSg+qOiI/GaCyEAHTx1q0EDfKN/N5GfsBHfH950LMH8rGuU/enCEgEoyFCcZY+hRl5opkayR4Ir8ecFt3IeTSwLHRw+260Avmjz7zkGf9pbUzEWjkjRKPapVkVN2SVXw3gVb+4ejK+uvh6T2JhAt5kYv44yc56aPkaJu8nccGJADItpS18Xy5VYfVloRokZwHT1kZVppfqvNEoyrtxIS2jA7Xc1Ad/Au2PFMphtQS/bFWmq38A1IofxVnPqLVh9WWiP9CS4aqrIyTZrBJmZcm98+9kpjAafqM075LabMujMo6jqtkf1b1bn3LNvtsMqtNMv8ggDvtDJNmhB+mv/e3r9/v/CHHG/lJt9t1wA2SRnfoNdNh4OeI1Pj2Apc/qPSUCeodnOQxicqO7Zq6Q0kxMk0vvVAMFvI3Ft5KZrAaBl+k+IULweh6RPFCmGWKYWXOaXwq6MfhNsln8OJOcptTA78woIP959I6GTY2cSTR6QzglN33FEI4B9qfXAWeJSvuD14FudYRF0yWzyMHnXTZKyTErDHSUGW/hVdX2M0POJ6J50UD2HkOpzx6uBLS0p54jyd4tsIrtJvRD7m7Xa7AVfV6qOt9Yt42m8WIAIc3HmbD8457inML7zvknrzeHLiyna2ycvQYYbEKCwQe8Rdod4/+ew4aThaFXWtOxqoW+zt7OsEj1qqoNrAxq9xap5FT165P9z/pDKuXobE8W6u+AecwAwe4Xfl70fOcdAA0ZV1VZTQXYuDleRs2cnfinZvuO+IWdnx5odvIvy3iXv5dX6COa5gLFDQ468Kfx81AA3Q5tpuTsdj2YwMmTG6+OcJqIgTNcsYc7mMEHs4E4Zv43so9T3C8wb3XDKXLae5iO9bxtNn9tTAIJmHnrWm3xRgZWj/zwjiHVNwtXaeLO9K36a/FKBk3FhSEuRbpoSm0vR3HJ4597a0lkq9oemUv3sVlEge5rPjjDX1prCPC0Wp9nZEjll1024oBbLRueTbrErToQUobXYw6ScDUDK94YGdiGKLpKe1EN/ydkY+cbLNSKmpxBWIsZa6bbw/b/KmtCPu8IX6XjB71W7jeEOpJA34p6eFp0q33cjtzLPya19JTcANTNq5AkohBoNJUMua2EGXPGdbHNhu8MxvNGyyKLqm1Gojf2Jj+852cLOvsPJNmgP62LukOIBNXfynkX1NCdB0EW2uXcfjb4N5NnYUG/zhvmAaL8vhfwFKP7HWRU+RBmv5JwsVVDZWhSK7svjPEP0H5PbNVjqrtFMAAAAASUVORK5CYII=');
        background-position: center center;
        background-size: cover;
        margin-right: 10px;
      }
    }

    label ~ label {
      color: #EAB659;

      &::before {
        background-image: url('data:image/svg+xml;base64,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');
      }
    }
  }

  .type-filters {

    &::before {
      content: '';
      display: block;
      width: 65px;
      height: 1px;
      background-color: #bfc5ca;
      margin: 10px auto 20px;
    }

    input {
      display: none;
    }

    label {
      position: relative;
      display: block;
      margin: 10px 0;
      padding-left: 30px;
      color: #565656;
      cursor: pointer;
    }

    label::before,
    label::after {
      position: absolute;
      content: "";
      display: inline-block;
    }

    label::before {
      height: 16px;
      width: 16px;
      border: 1px solid #565656;
      left: 0;
      top: 0;
      background-color: white;
    }

    label::after {
      color: #fff;
      height: 5px;
      width: 9px;
      border-left: 2px solid;
      border-bottom: 2px solid;
      transform: rotate(-45deg);
      left: 4px;
      top: 4px;
    }

    input[type="checkbox"] + label::after {
      content: none;
    }

    input[type="checkbox"]:checked + label::after {
      content: "";
    }

    input[type="checkbox"]:checked + label::before {
      background-color: #19314a;
    }

    input[type="checkbox"]:focus + label::before {
      outline: rgb(59, 153, 252) auto 5px;
    }
  }

</style>
